import * as React from "react";
const SvgFiRrAngel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-angel_svg__a)">
      <path
        fill="#062147"
        d="M12 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m11.448 13.382A2.01 2.01 0 0 1 22 17c0 1.103-.897 2-2 2 0 0-.003 2.078-.007 2.116a2.994 2.994 0 0 1-2.995 2.885H7a2.99 2.99 0 0 1-2.501-1.343 3 3 0 0 1-.5-1.712v-1.945c-1.102 0-2-.897-2-2a2.01 2.01 0 0 1-1.446-.618 2 2 0 0 1-.551-1.467C.184 10.849 1.025 6 4 6c3.41 0 5.729 2.804 6.405 3.736 1.036.35 2.153.35 3.189 0C14.27 8.804 16.589 6 19.999 6c2.976 0 3.817 4.849 3.999 8.916a2 2 0 0 1-.55 1.466M4 16v1h1a1 1 0 0 1 .518.144l3.085-6.473C7.929 9.819 6.228 7.999 4 7.999c-.83 0-1.804 2.62-2 7.006l1-.006a1 1 0 0 1 1 1zm13.919 4.61-4.207-8.824a6.96 6.96 0 0 1-3.424 0L6.06 20.651a.9.9 0 0 0-.061.241s-.055.36.167.66c.202.275.492.447.833.447h9.998a.98.98 0 0 0 .833-.448.98.98 0 0 0 .087-.941M22 15c-.196-4.38-1.171-7-2-7-2.228 0-3.93 1.82-4.603 2.672l3.085 6.473A1 1 0 0 1 19 17h1v-1a1 1 0 0 1 1-1zM8 4.25a1 1 0 0 0 1-1C9 2.81 10.139 2 12 2s3 .81 3 1.25a1 1 0 1 0 2 0C17 1.397 14.85 0 12 0S7 1.397 7 3.25a1 1 0 0 0 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-angel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAngel;
